import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from '@/locales/zh-CN'
import enUS from '@/locales/en-US'

Vue.use(VueI18n)

// 获取浏览器语言设置
const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : 'zh-CN'
const lang = localStorage.getItem('lang') || localLang

// 创建i18n实例
const i18n = new VueI18n({
  locale: lang,  // 设置语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  },
  silentTranslationWarn: true // 禁用翻译警告
})

export default i18n 